module.exports = __webpack_public_path__ + "static/img/10.5d0662a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/10.jpg
// module id = hWG6
// module chunks = 1